import { API, Endpoints } from '@brg/api';
import { useEffect, useState } from "react";
import useLocalization from "../useLocalization";
export var useGetLesson = function (lessonId) {
    var _a = useState(undefined), resp = _a[0], setResp = _a[1];
    var _b = useState(false), isLoading = _b[0], setIsLoading = _b[1];
    var _c = useState(false), error = _c[0], setError = _c[1];
    var language = useLocalization().language;
    useEffect(function () {
        if (!lessonId)
            return;
        setIsLoading(true);
        API.request()
            .endpoint(Endpoints.geoGateway)
            .url('/api/LMS/GetThemeLesson')
            .get()
            .addQuery('lessonId', lessonId || '')
            .send()
            .then(function (r) { return r ? r.json() : undefined; })
            .then(function (r) {
            setIsLoading(false);
            if (r && r.status === 403) {
                setResp(null);
                setError(true);
            }
            else {
                setResp(r);
            }
        })
            .catch(function (e) {
            setIsLoading(false);
            setError(true);
        });
    }, [lessonId]);
    return [API.toLang(resp, language), isLoading, error];
};
//# sourceMappingURL=useGetLesson.js.mapimport { API, Endpoints } from '@brg/api';
import { useEffect, useState } from "react";
import useLocalization from "../useLocalization";
export var useGetLesson = function (lessonId) {
    var _a = useState(undefined), resp = _a[0], setResp = _a[1];
    var _b = useState(false), isLoading = _b[0], setIsLoading = _b[1];
    var _c = useState(false), error = _c[0], setError = _c[1];
    var language = useLocalization().language;
    useEffect(function () {
        if (!lessonId)
            return;
        setIsLoading(true);
        API.request()
            .endpoint(Endpoints.geoGateway)
            .url('/api/LMS/GetThemeLesson')
            .get()
            .addQuery('lessonId', lessonId || '')
            .send()
            .then(function (r) { return r ? r.json() : undefined; })
            .then(function (r) {
            setIsLoading(false);
            if (r && r.status === 403) {
                setResp(null);
                setError(true);
            }
            else {
                setResp(r);
            }
        })
            .catch(function (e) {
            setIsLoading(false);
            setError(true);
        });
    }, [lessonId]);
    return [API.toLang(resp, language), isLoading, error];
};
//# sourceMappingURL=useGetLesson.js.map